import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { BRAND } from "../data/experiences";

const LINKS = [
  { to: "/", label: "Home" },
  { to: "/experiences", label: "Experiences" },
  { to: "/blog", label: "Blog" },
  { to: "/about", label: "About" },
  { to: "/contact", label: "Contact" },
];

export const Navbar = () => {
  const [mobile, setMobile] = useState(false);
  const location = useLocation();
  useEffect(() => setMobile(false), [location]);
  useEffect(() => {
    const dismiss = (event) => { if (event.key === "Escape") setMobile(false); };
    document.addEventListener("keydown", dismiss);
    return () => document.removeEventListener("keydown", dismiss);
  }, []);

  return (
    <header data-testid="main-navbar" className="fixed top-0 inset-x-0 z-[80] bg-ivory/95 backdrop-blur-md border-b border-maroon/15">
      <div className="editorial-container h-24 flex items-center justify-between gap-5">
        <Link to="/" data-testid="nav-logo" aria-label="Unzip Delhi home"><img src={BRAND.wordmark} alt="Unzip Delhi" width="860" height="604" className="w-20 h-auto object-contain" data-testid="nav-wordmark" /></Link>
        <nav className="hidden lg:flex items-center gap-7" aria-label="Main navigation" data-testid="desktop-navigation">
          {LINKS.map((link) => <Link key={link.to} to={link.to} data-testid={`nav-link-${link.label.toLowerCase()}`} aria-current={location.pathname === link.to ? "page" : undefined} className={`text-xs tracking-[0.1em] uppercase py-3 border-b transition-colors ${location.pathname === link.to ? "text-maroon border-maroon" : "text-obsidian/70 border-transparent hover:text-maroon hover:border-maroon/40"}`}>{link.label}</Link>)}
          <Link to="/contact" className="editorial-button" data-testid="nav-book-walk-button">Book a Walk</Link>
        </nav>
        <button data-testid="nav-mobile-menu-button" className="lg:hidden text-maroon p-3" onClick={() => setMobile(!mobile)} aria-label={mobile ? "Close menu" : "Open menu"} aria-expanded={mobile} aria-controls="mobile-navigation">{mobile ? <X size={24} /> : <Menu size={24} />}</button>
      </div>
      {mobile && (
        <nav id="mobile-navigation" aria-label="Mobile navigation" className="lg:hidden bg-ivory border-t border-maroon/15 max-h-[calc(100dvh-96px)] overflow-y-auto" data-testid="nav-mobile-menu">
          <div className="editorial-container py-6 flex flex-col gap-2">
            {LINKS.map((link) => <Link key={link.to} to={link.to} data-testid={`nav-mobile-link-${link.label.toLowerCase()}`} aria-current={location.pathname === link.to ? "page" : undefined} className="text-maroon text-lg font-accent py-2">{link.label}</Link>)}
            <Link to="/contact" className="editorial-button mt-3" data-testid="nav-mobile-book-walk-button">Book a Walk</Link>
          </div>
        </nav>
      )}
    </header>
  );
};
